module.exports = __webpack_public_path__ + "static/media/aurecon.337a8eb8.png";